import React from "react";
import styles from "./PasswordRequirementsList.module.css";
import { SPECIAL_CHAR_REGEX } from "../../utils/passwordValidation";

export interface PasswordRequirementsListProps {
  password: string;
}

interface PasswordRequirement {
  label: string;
  met: boolean;
}

const PasswordRequirementsList = ({
  password,
}: PasswordRequirementsListProps): React.JSX.Element => {
  const requirements: PasswordRequirement[] = [
    {
      label: "Between 8 and 128 characters",
      met: password.length >= 8 && password.length <= 128,
    },
    { label: "One lowercase letter", met: /[a-z]/.test(password) },
    { label: "One uppercase letter", met: /[A-Z]/.test(password) },
    { label: "One number", met: /[0-9]/.test(password) },
    { label: "One special character", met: SPECIAL_CHAR_REGEX.test(password) },
  ];

  return (
    <div className={styles["password-requirements"]}>
      <p className={styles["requirements-title"]}>Password must contain:</p>
      <ul className={styles["requirements-list"]}>
        {requirements.map((requirement) => (
          <li
            key={requirement.label}
            className={requirement.met ? styles.valid : styles.invalid}
          >
            {requirement.met ? "✓ " : ""}
            {requirement.label}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PasswordRequirementsList;
